export const isFileExist = (filesList: any, fileId: number) => {
  for (const category in filesList) {
    if (Array.isArray(filesList[category])) {
      const exists = filesList[category].some(
        (item: any) => item.fileCategoryRelationId === fileId
      );
      if (exists) return true;
    }
  }
  return false;
};
